import { ModalBlockParts } from '@lib/services';
import { FlightMealRequestComponent } from './flight-meal-request.component';
import { LModalContentsWidthType, ModalType } from '@lib/components';

/**
 * 機内食申込画面 (S02-M017)のペイロード
 * @param FlightMealRequestPayload
 */
export interface FlightMealRequestPayload {}

/**
 * 機内食申込(S02-M017)をモーダル表示する。
 * 呼び出しパラメータ
 */
export function flightMealRequestPayloadParts(): ModalBlockParts {
  return {
    id: 'FlightMealRequestComponent',
    block: FlightMealRequestComponent,
    closeBackEnable: false,
    type: ModalType.TYPE4,
    modalWidth: LModalContentsWidthType.NONE,
    payload: {} as FlightMealRequestPayload,
  };
}
